import {CityComponent} from '../../../real-time/city/city.component';
import {ChangeDetectorRef, Component, Inject, NgZone, OnInit} from '@angular/core';
import {RealTimeContextService} from 'app/real-time/real-time-context.service';
import {MapContextService} from 'app/common/map-context.service';
import {CITY} from 'app/common/const';
import {LayerService} from 'app/common/services/layer.service';
import {MvtService} from '../../../common/services/mvt.service';
import {VIEW_MODES} from '../../../real-time/real-time/real-time.component';
import {MadridCentralLayer} from '../layers/madridCentralLayer';
import {WazeInformoLayer} from '../layers/wazeLayer';
import {UpcomingLayer} from '../layers/upcomingLayer';
import {PlatesRestrictionLayer} from '../layers/platesRestrictionLayer';
import {StartingLayer} from '../layers/startingLayer';
import {DestinationLayer} from '../layers/destinationLayer';
import {RoutingLayer} from '../layers/routingLayer';
import {LAYERS_ID} from '../layers/constants';

@Component({
    selector: 'informo-component',
    templateUrl: './informo.component.html',
    styleUrls: ['./informo.component.scss']
})

export class InformoComponent extends CityComponent implements OnInit {

    constructor(protected realTimeContextService: RealTimeContextService,
                protected mapContext: MapContextService,
                protected layerService: LayerService,
                @Inject(CITY) protected city,
                protected mvtService: MvtService,
                protected cdr: ChangeDetectorRef,
    ) {
        super(
            realTimeContextService,
            mapContext,
            layerService,
            city,
            mvtService);
    }

    ngOnInit() {
        this._loadFAQLink();
        super.ngOnInit();
    }

    getLayers() {
        return [
            {
                id: LAYERS_ID.MADRID_CENTRAL_LAYER,
                layer: new MadridCentralLayer(this.mvtService),
                modes: [VIEW_MODES.LIVE, VIEW_MODES.UPCOMING],
            },
            {
                id: LAYERS_ID.WAZE_INFORMO_LAYER,
                layer: new WazeInformoLayer(this.city, this.mvtService),
                modes: [VIEW_MODES.LIVE],
            },
            {
                id: LAYERS_ID.UPCOMING_INFORMO_LAYER,
                layer: new UpcomingLayer(this.city, this.mvtService),
                modes: [VIEW_MODES.UPCOMING],
            },
            {
                id: LAYERS_ID.PLATES_RESTRICTION_INFORMO_LAYER,
                layer: new PlatesRestrictionLayer(this.mvtService),
                modes: [VIEW_MODES.PLATES],
            },
            {
                id: LAYERS_ID.STARTING_INFORMO_LAYER,
                layer: new StartingLayer(),
                modes: [VIEW_MODES.ROUTES],
            },
            {
                id: LAYERS_ID.DESTINATION_INFORMO_LAYER,
                layer: new DestinationLayer(),
                modes: [VIEW_MODES.ROUTES],
            },
            {
                id: LAYERS_ID.ROUTING_INFORMO_LAYER,
                layer: new RoutingLayer(this.city, this.selectedMode),
                modes: [VIEW_MODES.ROUTES],
            }
        ];
    }

    getAllowUpdateLayersIds() {
        return [
            LAYERS_ID.WAZE_INFORMO_LAYER,
            LAYERS_ID.UPCOMING_INFORMO_LAYER,
        ];
    }

    addStarting(start) {
        if (!start) {
            this.layerService.hideLayer(LAYERS_ID.ROUTING_INFORMO_LAYER);
        }
        this.layerService.getLayer(LAYERS_ID.STARTING_INFORMO_LAYER).update(start);
    }

    addDestination(dest) {
        if (!dest) {
            this.layerService.hideLayer(LAYERS_ID.ROUTING_INFORMO_LAYER);
        }
        this.layerService.getLayer(LAYERS_ID.DESTINATION_INFORMO_LAYER).update(dest);
    }

    addRouteLayer(route) {
        this.layerService.getLayer(LAYERS_ID.ROUTING_INFORMO_LAYER).updateRoute(route);
    }

    showRestrictedArea(event) {
        this.layerService.getLayer(LAYERS_ID.PLATES_RESTRICTION_INFORMO_LAYER).updateFilters(event);
    }


    updateComponentView(mode, source, categories) {
      super.updateComponentView(mode, source, categories)
      this.updateSources()
    }

    updateSources() {
      super.updateSources();
      if (this.selectedMode.mode === VIEW_MODES.LIVE) {
        this.interval = setInterval(() => {
          if (this.layerService.hasLayer(LAYERS_ID.WAZE_INFORMO_LAYER)) {
            this.layerService.getLayer(LAYERS_ID.WAZE_INFORMO_LAYER).updateSource();
          }
        }, 120000);
      }
    }

  private _loadFAQLink() {
        if (!window.matchMedia(`(max-width: 600px)`).matches) {
            document.querySelector('app-header')['style'].width = 'calc(100% - 60px)';
        }

    }
}



// WEBPACK FOOTER //
// ./src/app/cities/informo/informo/informo.component.ts